export default __webpack_public_path__ + "static/media/logo.881ba7c1.svg";